'use client';

import { Typography } from 'components';
import { ProcessingIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { cn } from 'utils/cn';

export default function ChatMsgProcessing() {
  const t = useTranslations();

  return (
    <div className="grid grid-cols-[32px__1fr_32px] gap-4">
      <div className="col-span-1">
        <Image
          alt="ai-icon"
          className=" h-8 shrink-0 rounded-full bg-white"
          height={32}
          width={32}
          src={'/images/icons/ai_light.svg'}
          priority={false}
        />
      </div>
      <div className={cn('col-span-1', 'rounded-3xl border p-3', 'rounded-tl-none bg-white')}>
        <div className="flex gap-4">
          <ProcessingIcon className="animate-spin" />
          <Typography variant="light4" className="text-tertiary-300 ">
            {t('chat.processing')}
          </Typography>
        </div>
      </div>
    </div>
  );
}
